import { UploadFile } from 'antd'
import { AnyObject } from 'antd/es/_util/type'
import { RcFile } from 'antd/es/upload'
import { UploadFileStatus } from 'antd/es/upload/interface'

export type MediaData = {
  id?: string
  uid: string
  url?: string
  name?: string
  size?: number
  type?: string
  modified_at?: string
  permission?: number
  status?: UploadFileStatus
  content_type?: string
  created_by?: AnyObject
  width?: number
  height?: number
}

export enum SelectType {
  NEW = 'new',
  EXIST = 'exist'
}

export type FormMediaValues = {
  url: string
  name: string
  description: string
  file?: UploadFile[]
  originFileObj?: RcFile
  type?: string
}

export type Media = MediaData & FormMediaValues

export enum MediaStatus {
  ALL = 'all',
  DRAFT = 'draft',
  PUBLISHED = 'published'
}

export type MediaFilters = {
  pageNumber: number
  pageSize: number
  contentType?: string
  search?: string
  status?: MediaStatus
}

export type PaginatedMedia = {
  count: number
  next: string | null
  previous: string | null
  results: Media[]
}
